// extracted by mini-css-extract-plugin
export var closeButton = "_gn-2";
export var closeButtonIcon = "_gn-3";
export var lightboxContent = "_gn-1";
export var lightboxOverlay = "_gn-0";